<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <div class="float-left">
                    <span class="h5">Medição</span>
                </div>
                <div class="float-right">
                    <button class="btn btn-danger" @click.stop="voltar()">
                        <i class="fa fa-arrow-left mr-2"></i>Voltar para lista de boletins
                    </button>
                </div>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                />

                <b-alert show :variant="obterClasseCorStatusBoletimMedicao(boletimMedicao.status)">
                    <b-row>
                        <b-col>
                            <div class="float-left mt-2">
                                <i class="fa fa-info-circle fa-3x mt-2 ml-2"></i>
                            </div>
                            <div class="float-left ml-3 mt-2 text-dark">
                                <span class="h4">BM {{ obterDescricaoStatusBoletimMedicao(boletimMedicao.status) }}</span>
                                <p>{{ boletimMedicao.nome }}</p>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <div v-if="historicoMaisRecente" class="card-text mt-1">
                                <b-button v-for="(anexo, index) in historicoMaisRecente.anexos" :key="index"
                                    pill
                                    variant="light"
                                    class="mr-2"
                                    v-b-tooltip.hover
                                    title="Clique para fazer o download"
                                    @click="downloadAnexoHistorico(anexo)"
                                >
                                    <i class="fa fa-paperclip"></i> {{ anexo.nomeArquivo }} ({{ anexo.tamanho | tamanhoArquivoFormatado }})
                                </b-button>

                            </div>
                        </b-col>
                    </b-row>
                </b-alert>

                <b-row>
                    <b-col class="mt-3">
                        <abas
                            :visualizacaoAbasBoletinsMedicao="visualizacaoAbasBoletinsMedicao"
                            :abas-em-ajuste="abasEmAjuste"
                            :abas-com-check-manual="abasComCheckManual"
                            :contratoIdProp="contrato.contratoId"
                            :boletimMedicaoIdProp="boletimMedicao.boletimMedicaoId"
                            @abaSelecionada="abaSelecionada"
                        >
                            <template #conteudo-aba-dados_gerais>
                                <p v-if="numeroAditivoDoBoletim" class="font-weight-bold">
                                    Nº Aditivo: {{ numeroAditivoDoBoletim }}
                                </p>
                                <b-card-text>
                                    <boletim-medicao-detalhes
                                        :contrato="contrato"
                                        :boletimMedicao="boletimMedicao"
                                        @recarregarDadosBoletim="obterBoletimMedicao"
                                    />
                                </b-card-text>

                                <b-row>
                                    <b-col class="mt-3">
                                        <b-button
                                            class="mr-2"
                                            @click.stop="voltar()"
                                            variant="warning"
                                        >
                                            <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Voltar
                                        </b-button>

                                        <b-button
                                            v-if="boletimEditavel"
                                            class="mr-2"
                                            variant="outline-primary"
                                            @recarregarDadosBoletim="obterBoletimMedicao"
                                            @click.stop="atualizarBoletimMedicao()"
                                        >
                                            Atualizar
                                        </b-button>

                                        <b-button
                                            v-if="mostrarExcluir"
                                            class="mr-2"
                                            variant="danger"
                                            @click.stop="excluir()"
                                        >
                                            <i class="fa fa-trash mr-2"></i>Excluir BM
                                        </b-button>

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoEnviarParaAprovacao"
                                            :disabled="!habilitarBotaoEnviarParaAprovacao"
                                            :titulo="'Enviar de Boletim de Medição para Aprovação'"
                                            :textoBotao="'Enviar para aprovação'"
                                            :mensagemConfirmacao="mensagemConfirmacaoEnvioParaAprovacao"
                                            :iconeBotao="'fa-check'"
                                            :variantBotao="'success'"
                                            :etapa="etapaBoletimMedicaoEnum.EnvioBoletimMedicaoParaAprovacao"
                                            :tooltip="tooltipEnviarParaAprovacao"
                                            @concluirEtapa="concluirEtapa"
                                        ></btn-conclusao-etapa>

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoDevolverParaCorrecao"
                                            :titulo="'Devolução do Boletim de Medição para Correção'"
                                            :textoBotao="'Devolver para correção'"
                                            :mensagemConfirmacao="'Deseja realmente devolver o Boletim de Medição para correção?'"
                                            :iconeBotao="'fa-undo'"
                                            :variantBotao="'warning'"
                                            :etapa="etapaBoletimMedicaoEnum.DevolucaoBoletimMedicaoParaCorrecao"
                                            :itens-aprovados="itensAprovados"
                                            :total-itens="totalItensAprovacao"
                                            @concluirEtapa="concluirEtapa"
                                        ></btn-conclusao-etapa>

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoEnviarParaAprovacaoFiscalObras"
                                            :titulo="'Aprovar Boletim de Medição para Aprovação de Suape'"
                                            :textoBotao="'Enviar para Aprovação de Suape'"
                                            :mensagemConfirmacao="'Deseja realmente aprovar o Boletim de Medição?'"
                                            :iconeBotao="'fa-check'"
                                            :variantBotao="'success'"
                                            :etapa="etapaBoletimMedicaoEnum.EnvioParaAprovacaoFiscalObras"
                                            @concluirEtapa="concluirEtapa"
                                        />

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoEnviarParaColetaAssinaturaFornecedor"
                                            :disabled="!podeAprovarBoletimFiscalObras"
                                            :titulo="'Aprovar Boletim de Medição para Coleta da Assinatura do Fornecedor'"
                                            :textoBotao="'Enviar para Coleta da Assinatura do Fornecedor'"
                                            :mensagemConfirmacao="'Deseja realmente aprovar o Boletim de Medição para coleta da assinatura do fornecedor?'"
                                            :iconeBotao="'fa-check'"
                                            :variantBotao="'success'"
                                            :etapa="etapaBoletimMedicaoEnum.AprovacaoParaColetaAssinaturaFornecedor"
                                            :itens-aprovados="itensAprovados"
                                            :total-itens="totalItensAprovacao"
                                            @concluirEtapa="concluirEtapa"
                                        />

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoAprovarParaColetaAssinaturaFiscalObras"
                                            :disabled="!podeAprovarParaColetaAssinaturaFiscalObras"
                                            :tooltip="tooltipAprovarParaColetaAssinaturaFiscalObras"
                                            :titulo="'Confirmar Assinaturas do Boletim de Medição'"
                                            :textoBotao="'Confirmar Assinaturas'"
                                            :mensagemConfirmacao="'Deseja realmente confirmar as assinaturas do Boletim de Medição?'"
                                            :iconeBotao="'fa-check'"
                                            :variantBotao="'success'"
                                            :etapa="etapaConfirmarAssinaturas"
                                            @concluirEtapa="concluirEtapa"
                                        />

                                        <modal-aprovar-documentos-suape
                                            v-if="mostrarBotaoAprovarDocumentosSuape"
                                            :contrato="contrato"
                                            :boletimMedicao="boletimMedicao"
                                            @concluirEtapa="concluirEtapa"
                                        />

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoEnviarNotaFiscalParaAprovacao"
                                            :titulo="'Confirmar envio da Nota Fiscal'"
                                            :textoBotao="'Enviar Nota Fiscal'"
                                            :mensagemConfirmacao="'Deseja realmente confirmar o envio da Nota Fiscal do Boletim de Medição?'"
                                            :iconeBotao="'fa-check'"
                                            :variantBotao="'success'"
                                            :etapa="etapaBoletimMedicaoEnum.EnvioNotaFiscalParaAprovacao"
                                            @concluirEtapa="concluirEtapa"
                                        ></btn-conclusao-etapa>

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoDevolverNotaFiscalParaCorrecao"
                                            :titulo="'Devolução da Nota Fiscal para Correção'"
                                            :textoBotao="'Devolver Nota Fiscal para correção'"
                                            :mensagemConfirmacao="'Deseja realmente devolver a Nota Fiscal para correção?'"
                                            :iconeBotao="'fa-undo'"
                                            :variantBotao="'warning'"
                                            :etapa="etapaBoletimMedicaoEnum.DevolucaoNotaFiscalParaCorrecao"
                                            @concluirEtapa="concluirEtapa"
                                        ></btn-conclusao-etapa>

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoAprovacaoParaCadastroRequisicao"
                                            :titulo="'Aprovação para Cadastro da Requisição'"
                                            :textoBotao="'Aprovar para Cadastro da Requisição'"
                                            :mensagemConfirmacao="'Deseja realmente confirmar a aprovação para Cadastro da Requisição?'"
                                            :iconeBotao="'fa-check'"
                                            :variantBotao="'success'"
                                            :etapa="etapaBoletimMedicaoEnum.AprovacaoParaCadastroRequisicao"
                                            @concluirEtapa="concluirEtapa"
                                        ></btn-conclusao-etapa>

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoReiniciarProcesso"
                                            :titulo="'Reiniciar Processo de validação de Boletim de Medição'"
                                            :textoBotao="'Reiniciar Processo'"
                                            :mensagemConfirmacao="'Deseja realmente confirmar o reinicio do Processo de validação de Boletim de Medição?'"
                                            :iconeBotao="'fa-undo'"
                                            :variantBotao="'warning'"
                                            :etapa="etapaBoletimMedicaoEnum.ReinicioProcesso"
                                            @concluirEtapa="concluirEtapa"
                                        ></btn-conclusao-etapa>

                                        <btn-conclusao-etapa
                                            v-if="mostrarBotaoGerarRequisicaoBoletimMedicao"
                                            :titulo="'Geração da Requisição de Boletim de Medição'"
                                            :textoBotao="'Gerar Requisição'"
                                            :mensagemConfirmacao="'Deseja realmente confirmar a geração da Requisição para o Boletim de Medição?'"
                                            :iconeBotao="'fa-check'"
                                            :variantBotao="'success'"
                                            :etapa="etapaBoletimMedicaoEnum.CadastroRequisicao"
                                            @concluirEtapa="concluirEtapa"
                                        ></btn-conclusao-etapa>

                                        <!-- Funcionalidade não vai ser usada -->
                                        <!--
                                        <btn-cancelar-boletim-medicao
                                            v-if="boletimMedicao.status == statusBoletimMedicaoEnum.Criado"
                                            :boletimMedicao="boletimMedicao"
                                            @confirmarCancelamentoBoletimMedicao="confirmarCancelamentoBoletimMedicao"
                                        />
                                        -->
                                    </b-col>
                                </b-row>
                            </template>

                            <template #conteudo-aba-planilha_medicao>
                                <boletim-medicao-cabecalho-aba class="mb-3">
                                    <b-card>
                                        <resumo-contratual
                                            :contrato="contratoDoBoletim"
                                            :boletimMedicao="boletimMedicao"
                                            :valorTotalTodosBoletins="valorTotalTodosBoletins"
                                            :fornecedorLogoUrl="fornecedorLogoItensMedicao"
                                            @recarregarDadosBoletim="obterBoletimMedicao"
                                        />
                                    </b-card>
                                </boletim-medicao-cabecalho-aba>
                                <boletim-medicao-itens
                                    :boletimMedicao="boletimMedicao"
                                    :contrato="contrato"
                                    :boletimEditavel="boletimEditavel"
                                    :valorTotalTodosBoletins="valorTotalTodosBoletins"
                                    :fornecedorLogoUrl="fornecedorLogoItensMedicao"
                                    @adicionarItensBoletimMedicao="adicionarItensBoletimMedicao"
                                    @excluirItemBoletimMedicao="excluirItemBoletimMedicao"
                                    @recarregarDadosBoletim="obterBoletimMedicao"
                                    @voltar="voltar"
                                    @concluirEtapa="concluirEtapa"
                                />
                            </template>

                            <template #conteudo-aba-memoria_calculo>
                                <div v-if="deveExibirCheckManual('MEMORIA_CALCULO')" class="check-manual-aba-banner">
                                    <b-form-checkbox
                                        :checked="isAbaVisualizada('MEMORIA_CALCULO')"
                                        @change="confirmarAbaManual('MEMORIA_CALCULO', $event)">
                                        Li e confirmo os dados desta aba
                                    </b-form-checkbox>
                                </div>
                                <boletim-medicao-cabecalho-aba class="mb-3">
                                    <b-card>
                                        <resumo-contratual-boletim-medicao
                                            :contrato="contratoDoBoletim"
                                            :boletimMedicao="boletimMedicao"
                                            :valorTotalTodosBoletins="valorTotalTodosBoletins"
                                            :fornecedorLogoUrl="fornecedorLogoMemoriaCalculo"
                                        />
                                    </b-card>
                                </boletim-medicao-cabecalho-aba>
                                <memoria-calculo-tab
                                    :boletimMedicao="boletimMedicao"
                                    :isFornecedor="$store.getters.isFornecedor"
                                    :boletimEditavel="boletimEditavel"
                                    :contrato="contrato"
                                    :valorTotalTodosBoletins="valorTotalTodosBoletins"
                                    :fornecedorLogoUrl="fornecedorLogoMemoriaCalculo"
                                    :exibir-aprovacao-itens="isFiscalAprovandoFiscalObras"
                                    @recarregar-dados="recarregarBoletimELista"
                                    @update:itensAprovados="itensAprovados = $event"
                                ></memoria-calculo-tab>
                            </template>

                            <template #conteudo-aba-cronograma>
                                <div v-if="!temPlanejamentoDoBoletim" class="alert alert-warning mt-3">
                                    <i class="fa fa-exclamation-triangle mr-2"></i>
                                    Esta funcionalidade requer que o contrato tenha um Planejamento Físico-Financeiro cadastrado.
                                </div>
                                <b-card-text>
                                    <boletim-medicao-cabecalho-aba class="mb-3">
                                        <contrato-header
                                            v-if="dadosContratoHeader"
                                            :dados="dadosContratoHeader"
                                        />
                                    </boletim-medicao-cabecalho-aba>
                                    <div class="mt-3">
                                        <boletim-medicao-cronograma
                                            v-if="abaCronogramaAtiva"
                                            :boletimMedicao="boletimMedicao"
                                            :indiceFixoBm="boletimMedicao.numero"
                                            :contrato-id="boletimMedicao.contratoId || contrato.contratoId"
                                            :contrato="contrato"
                                            :boletim-medicao-id="boletimMedicao.boletimMedicaoId"
                                            :todos-boletins-medicoes="todosBoletinsMedicoes"
                                            :exibir-realizado="true"
                                            :exibir-todos-bms="true"
                                            :logo-fornecedor-url="fornecedorLogoUrl"
                                            @recarregarDadosBoletim="obterBoletimMedicao"
                                        />
                                    </div>
                                </b-card-text>
                            </template>

                            <template #conteudo-aba-curva_s>
                                <b-card-text>
                                    <resumo-contratual-curva-s
                                        :contrato="contratoDoBoletim"
                                        :boletimMedicao="boletimMedicao"
                                        :valorTotalTodosBoletins="valorTotalTodosBoletins"
                                        :fornecedorLogoUrl="fornecedorLogoCurvaS"
                                    />
                                    <div v-if="!temPlanejamentoDoBoletim" class="alert alert-warning mt-3">
                                        <i class="fa fa-exclamation-triangle mr-2"></i>
                                        Esta funcionalidade requer que o contrato tenha um Planejamento Físico-Financeiro cadastrado.
                                    </div>
                                    <curva-s-tab
                                        v-else
                                        :contrato-id="boletimMedicao.contratoId || contrato.contratoId"
                                        :boletim-medicao="boletimMedicao"
                                        :todos-boletins-medicoes="todosBoletinsMedicoes"
                                        :tem-planejamento="temPlanejamentoDoBoletim"
                                        :contrato="contrato"
                                        :valor-total-todos-boletins="valorTotalTodosBoletins"
                                        :fornecedorLogoUrl="fornecedorLogoCurvaS"
                                        @voltar="voltar"
                                        @recarregarDadosBoletim="obterBoletimMedicao"
                                    />
                                </b-card-text>
                            </template>

                            <template #conteudo-aba-declaracao_vinculos>
                                <div v-if="deveExibirCheckManual('DECLARACAO_VINCULOS')" class="check-manual-aba-banner">
                                    <b-form-checkbox
                                        :checked="isAbaVisualizada('DECLARACAO_VINCULOS')"
                                        @change="confirmarAbaManual('DECLARACAO_VINCULOS', $event)">
                                        Li e confirmo os dados desta aba
                                    </b-form-checkbox>
                                </div>
                                <b-card-text>
                                    <div class="mt-3">
                                        <declaracao-vinculo-tab
                                            ref="declaracaoVinculoTab"
                                            v-if="abaDeclaracaoVinculoAtiva && dadosContratoHeader"
                                            :dadosHeader="dadosContratoHeader"
                                            :boletim-medicao="boletimMedicao"
                                            :boletimMedicaoId="boletimMedicao.boletimMedicaoId"
                                            :contratoId="boletimMedicao.contratoId || contrato.contratoId"
                                            :contrato="contrato"
                                            :itens="itensDeclaracaoVinculo"
                                            :cnpjContratada="contrato.fornecedor ? contrato.fornecedor.cnpj : ''"
                                            :editavel="declaracaoVinculoEditavel"
                                            :status-boletim-medicao="boletimMedicao.status"
                                            :nome-arquivo-existente="nomeAnexoDeclaracaoVinculoAssinado"
                                            @salvar="salvarProfissional"
                                            @atualizar="atualizarProfissional"
                                            @excluir="excluirProfissional"
                                            @recarregarDadosBoletim="obterBoletimMedicao"
                                        />
                                    </div>
                                </b-card-text>
                            </template>

                            <template #conteudo-aba-planta_falada>
                                <div v-if="deveExibirCheckManual('PLANTA_FALADA')" class="check-manual-aba-banner">
                                    <b-form-checkbox
                                        :checked="isAbaVisualizada('PLANTA_FALADA')"
                                        @change="confirmarAbaManual('PLANTA_FALADA', $event)">
                                        Li e confirmo os dados desta aba
                                    </b-form-checkbox>
                                </div>
                                <boletim-medicao-planta-falada
                                    :contrato="contrato"
                                    :boletimMedicao="boletimMedicao"
                                    :editavel="plantaFaladaEditavel"
                                    :pode-trocar-imagem="podeTrocarImagemPlantaFalada"
                                    :fornecedorLogoUrl="fornecedorLogoPlantaFalada"
                                    @voltar="voltar"
                                    @recarregarDadosBoletim="obterBoletimMedicao"
                                    @proxima-etapa="plantaFaladaEtapaInterna = true"
                                    @voltar-etapa="plantaFaladaEtapaInterna = false"
                                />
                            </template>

                            <template #conteudo-aba-anexos>
                                <boletim-medicao-anexos
                                    :contrato="contrato"
                                    :boletimMedicao="boletimMedicao"
                                    :editavel="anexosEditavel"
                                    :anexosMedicao="boletimMedicao.anexos"
                                    @recarregarDadosBoletim="obterBoletimMedicao"
                                />
                                <b-row>
                                    <b-col class="mt-3">
                                        <b-button
                                            class="mr-2"
                                            @click.stop="voltar()"
                                            variant="warning"
                                        >
                                            <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Voltar
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </template>

                            <template #conteudo-aba-historico>
                                <boletim-medicao-historico
                                    :boletimMedicao="boletimMedicao"
                                    :contrato="contrato"
                                    :historicoMedicao="boletimMedicao.historico"
                                />
                                <b-row>
                                    <b-col class="mt-3">
                                        <b-button
                                            class="mr-2"
                                            @click.stop="voltar()"
                                            variant="warning"
                                        >
                                            <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Voltar
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </template>
                        </abas>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

        <modal-envio-documentos-sei
            :show="mostrarModalEnvioSei"
            :contrato-id="contrato.contratoId"
            :boletim-medicao-id="boletimMedicao.boletimMedicaoId"
            :numero-processo="contextoEnvioSei.numeroProcesso"
            :anexos="contextoEnvioSei.anexos"
            :parametros="contextoEnvioSei.parametros"
            @fechar="fecharModalEnvioSei"
            @concluido="concluirEnvioSei"
        />
    </div>
</template>

<script>

import BoletimMedicaoDetalhes from './componentes/abasMedicao/BoletimMedicaoDetalhes.vue';
import BoletimMedicaoItens from './componentes/abasMedicao/BoletimMedicaoItens.vue';
import BoletimMedicaoAnexos from './componentes/abasMedicao/BoletimMedicaoAnexos.vue';
import BoletimMedicaoHistorico from './componentes/abasMedicao/BoletimMedicaoHistorico.vue';
import BoletimMedicaoCronograma from './componentes/abasMedicao/BoletimMedicaoCronograma.vue';
import BoletimMedicaoPlantaFalada from './componentes/abasMedicao/BoletimMedicaoPlantaFalada.vue';
import ModalEnvioDocumentosSei from './componentes/ModalEnvioDocumentosSei.vue';
import ModalAprovarDocumentosSuape from './componentes/ModalAprovarDocumentosSuape.vue';
import BoletimMedicaoServicos from './BoletimMedicaoServicos.js';
import IntegracaoSeiDocumentosServicos from '@/shared/integracoes/integracaoSeiDocumentosServicos.js';
import BtnConclusaoEtapa from './componentes/BtnConclusaoEtapa.vue';
import BoletimMedicaoCabecalhoAba from './componentes/BoletimMedicaoCabecalhoAba.vue';
import ResumoContratual from './componentes/ResumoContratual.vue';
import ResumoContratualBoletimMedicao from './componentes/ResumoContratualBoletimMedicao.vue';
import ResumoContratualCurvaS from './componentes/ResumoContratualCurvaS.vue';
import MemoriaCalculoTab from '../../../contratos/components/memoria-de-calculo/MemoriaCalculoTab.vue'
import ContratoHeader from './componentes/abasMedicao/cronograma-planejamento/ContratoHeader.vue';
import CurvaSTab from './componentes/abasMedicao/curva-s/CurvaSTab.vue';
import DeclaracaoVinculoTab from './componentes/abasMedicao/declaracao-vinculo/DeclaracaoVinculoTab.vue';
import FornecedoresServicos from '../../../fornecedores/FornecedoresServicos.js';
import {
    obterDescricaoStatusBoletimMedicao,
    statusBoletimMedicaoEnum,
    statusItemBoletimMedicaoEnum,
    obterClasseCorStatusBoletimMedicao,
    etapaBoletimMedicaoEnum,
    obterDescricaoUnidadeMedidaItemContrato,
    tipoAnexoBoletimMedicaoEnum,
    abaBoletimMedicaoCodigo,
} from './BoletimMedicao.js';
import { tiposAnexo } from './tiposAnexo.js'
// Funcionalidade não vai ser usada
// import BtnCancelarBoletimMedicao from './componentes/BtnCancelarBoletimMedicao.vue';
import ContratosServicos from '../ContratosServicos.js';
import { mapaNumeroAditivoPorContrato } from './historicoAditivosUtils';
import Abas from './componentes/AbasComponent.vue';

export default {
    components: {
        BoletimMedicaoDetalhes,
        BoletimMedicaoItens,
        BoletimMedicaoAnexos,
        BoletimMedicaoHistorico,
        // Funcionalidade não vai ser usada
        // BtnCancelarBoletimMedicao,
        BtnConclusaoEtapa,
        BoletimMedicaoCabecalhoAba,
        ResumoContratual,
        Abas,
        ResumoContratualBoletimMedicao,
        MemoriaCalculoTab,
        BoletimMedicaoCronograma,
        ResumoContratualCurvaS,
        ContratoHeader,
        CurvaSTab,
        DeclaracaoVinculoTab,
        BoletimMedicaoPlantaFalada,
        ModalEnvioDocumentosSei,
        ModalAprovarDocumentosSuape
    },

    props: {
        contrato: {
            type: Object,
            default: null
        },
        temPlanejamento: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            erros: [],
            statusBoletimMedicaoEnum: statusBoletimMedicaoEnum,
            abaBoletimMedicaoCodigo: abaBoletimMedicaoCodigo,
            etapaBoletimMedicaoEnum: etapaBoletimMedicaoEnum,
            boletimMedicao: {},
            historicoAditivos: [],
            historicoMaisRecente: {},
            visualizacaoAbasBoletinsMedicao: [],
            abaAtiva: 0,
            abaCronogramaAtiva: false,
            dadosContratoHeader: null,
            fornecedorLogoCurvaS: null,
            fornecedorLogoMemoriaCalculo: null,
            fornecedorLogoPlantaFalada: null,
            plantaFaladaEtapaInterna: false,
            fornecedorLogoItensMedicao: null,
            todosBoletinsMedicoes: [],
            abaDeclaracaoVinculoAtiva: false,
            itensDeclaracaoVinculo: [],
            declaracaoVinculoId: null,
            fornecedorLogoUrl: null,
            itensAprovados: [],
            mostrarModalEnvioSei: false,
            contextoEnvioSei: {
                numeroProcesso: '',
                anexos: [],
                parametros: {}
            },
            planejamentoDoBoletim: null,
        }
    },

    computed: {
        mostrarExcluir() {
            return this.$store.getters.isFornecedor
                && this.boletimMedicao
                && (this.boletimMedicao.status === this.statusBoletimMedicaoEnum.Criado
                    || this.boletimMedicao.status === this.statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor);
        },

        numeroAditivoDoBoletim() {
            const contratoId = this.boletimMedicao.contratoId || (this.contrato && this.contrato.contratoId);
            if (!contratoId) return null;
            return mapaNumeroAditivoPorContrato(this.historicoAditivos)[contratoId] || null;
        },

        contratoDoBoletim() {
            const base = this.contrato || {};
            const congelado = (this.boletimMedicao && this.boletimMedicao.contrato) || null;
            if (!congelado) return base;

            return {
                ...base,
                contratoId: congelado.contratoId || base.contratoId,
                codContrato: congelado.codContrato || base.codContrato,
                objeto: congelado.objeto || base.objeto,
                numeroLicitacao: congelado.numeroLicitacao || base.numeroLicitacao,
                inicioVigencia: congelado.inicioVigencia || base.inicioVigencia,
                fimVigencia: congelado.fimVigencia || base.fimVigencia,
                valorTotal: congelado.valorTotal || base.valorTotal,
                saldo: congelado.saldo || base.saldo,
                fornecedor: congelado.fornecedor || base.fornecedor
            };
        },

        temPlanejamentoDoBoletim() {
            return this.planejamentoDoBoletim && this.planejamentoDoBoletim.id != null;
        },

        boletimEditavel() {
            return !!this.boletimMedicao.editavel && this.$store.getters.isFornecedor
        },

        habilitarBotaoEnviarParaAprovacao() {
            return this.visualizacaoAbasBoletinsMedicao
                        .every(aba => ((aba.configuracaoAbaBoletimMedicao?.obrigatorio && aba.visualizada) || !aba.configuracaoAbaBoletimMedicao?.obrigatorio));
        },

        tooltipEnviarParaAprovacao() {
            if (this.habilitarBotaoEnviarParaAprovacao) return '';

            const abasPendentes = this.visualizacaoAbasBoletinsMedicao
                .filter(aba => aba.configuracaoAbaBoletimMedicao?.obrigatorio && !aba.visualizada)
                .map(aba => aba.abaBoletimMedicao?.nome || 'Aba sem nome');

            return abasPendentes.length
                ? `<div style="text-align: left">Abas pendentes:<br>${abasPendentes.map(n => `- ${n}`).join('<br>')}</div>`
                : '';
        },

        abasComCheckManual() {
            if (!this.$store.getters.isFornecedor) return []
            const statusMostrar = [
                statusBoletimMedicaoEnum.Criado,
                statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor,
            ]
            if (!statusMostrar.includes(this.boletimMedicao.status)) return []

            const abas = []
            const itens = this.boletimMedicao.itens || []
            const temItemEditavel = itens.some(i =>
                parseFloat(i.valorUnitario) !== 0 &&
                i.status !== statusItemBoletimMedicaoEnum.AprovadoFiscalObras
            )
            if (temItemEditavel) abas.push(abaBoletimMedicaoCodigo.MemoriaCalculo)
            if (this.boletimMedicao.plantaFaladaEditavel !== false) abas.push(abaBoletimMedicaoCodigo.PlantaFalada)
            if (this.boletimMedicao.declaracaoVinculoEditavel !== false) abas.push(abaBoletimMedicaoCodigo.DeclaracaoVinculos)
            return abas
        },

        mostrarBotaoEnviarParaAprovacao() {
            return ((this.boletimMedicao.status == statusBoletimMedicaoEnum.Criado ||
                this.boletimMedicao.status == statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor)
                && this.$store.getters.isFornecedor);
        },

        mostrarBotaoEnviarParaAprovacaoFiscalObras() {
            return (this.boletimMedicao.status == statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalTerceiro
                && this.$temAcessoView('FISCAL-TERCEIRO'));
        },

        mostrarBotaoEnviarParaColetaAssinaturaFornecedor() {
            return (this.boletimMedicao.status == statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalObras
                && (this.contrato.usuarioEhFiscalObra || this.contrato.usuarioEhOrdenador));
        },

        mostrarBotaoDevolverParaCorrecao() {
            return ((this.boletimMedicao.status == statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalTerceiro
                    && this.$temAcessoView('FISCAL-TERCEIRO'))
                || this.boletimMedicao.status == statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalObras)
                && (this.contrato.usuarioEhFiscalObra || this.contrato.usuarioEhOrdenador);
        },

        mostrarBotaoAprovarParaColetaAssinaturaFiscalObras() {
            return !this.boletimMedicao.contrato.possuiFiscalExterno
                && [
                    statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor,
                    statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor,
                ].includes(this.boletimMedicao.status)
                && this.$store.getters.isFornecedor;
        },

        etapaConfirmarAssinaturas() {
            return this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor
                ? etapaBoletimMedicaoEnum.ReenvioParaValidacaoAssinaturaFiscalObras
                : etapaBoletimMedicaoEnum.AprovacaoParaColetaAssinaturaFiscalObras;
        },

        mostrarBotaoAprovarDocumentosSuape() {
            return this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalObras
                && (this.contrato.usuarioEhFiscalObra || this.contrato.usuarioEhOrdenador);
        },

        podeAprovarParaColetaAssinaturaFiscalObras() {
            const anexos = this.boletimMedicao.anexos || [];
            const temAnexo = (tipo) => anexos.some(a => a.tipoAnexoBoletimMedicao === tipo);

            return temAnexo(tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFornecedor)
                && temAnexo(tipoAnexoBoletimMedicaoEnum.MemoriaCalculoAssinadaPeloFornecedor)
                && (!this.isAbaAtiva(abaBoletimMedicaoCodigo.Cronograma) || temAnexo(tipoAnexoBoletimMedicaoEnum.CronogramaFisicoFinanceiroAssinadoPeloFornecedor))
                && (!this.isAbaAtiva(abaBoletimMedicaoCodigo.CurvaS) || temAnexo(tipoAnexoBoletimMedicaoEnum.CurvaSAssinadaPeloFornecedor))
                && (!this.isAbaAtiva(abaBoletimMedicaoCodigo.PlantaFalada) || temAnexo(tipoAnexoBoletimMedicaoEnum.PlantaFaladaAssinadaPeloFornecedor))
                && (!this.isAbaAtiva(abaBoletimMedicaoCodigo.DeclaracaoVinculos) || temAnexo(tipoAnexoBoletimMedicaoEnum.DeclaracaoVinculoAssinadaPeloFornecedor));
        },

        tooltipAprovarParaColetaAssinaturaFiscalObras() {
            if (this.podeAprovarParaColetaAssinaturaFiscalObras) return '';

            const anexos = this.boletimMedicao.anexos || [];
            const temAnexo = (tipo) => anexos.some(a => a.tipoAnexoBoletimMedicao === tipo);

            const faltando = [];
            if (!temAnexo(tipoAnexoBoletimMedicaoEnum.MedicaoAssinadaPeloFornecedor))
                faltando.push('Planilha de Medição');
            if (!temAnexo(tipoAnexoBoletimMedicaoEnum.MemoriaCalculoAssinadaPeloFornecedor))
                faltando.push('Memória de Cálculo');
            if (this.isAbaAtiva(abaBoletimMedicaoCodigo.Cronograma) && !temAnexo(tipoAnexoBoletimMedicaoEnum.CronogramaFisicoFinanceiroAssinadoPeloFornecedor))
                faltando.push('Cronograma');
            if (this.isAbaAtiva(abaBoletimMedicaoCodigo.CurvaS) && !temAnexo(tipoAnexoBoletimMedicaoEnum.CurvaSAssinadaPeloFornecedor))
                faltando.push('Curva S');
            if (this.isAbaAtiva(abaBoletimMedicaoCodigo.PlantaFalada) && !temAnexo(tipoAnexoBoletimMedicaoEnum.PlantaFaladaAssinadaPeloFornecedor))
                faltando.push('Planta Falada');
            if (this.isAbaAtiva(abaBoletimMedicaoCodigo.DeclaracaoVinculos) && !temAnexo(tipoAnexoBoletimMedicaoEnum.DeclaracaoVinculoAssinadaPeloFornecedor))
                faltando.push('Declaração de Vínculo');

            return faltando.length ? `<div style="text-align: left">Abas pendentes:<br>${faltando.map(f => `- ${f}`).join('<br>')}</div>` : '';
        },


        nomeAnexoDeclaracaoVinculoAssinado() {
            if (this.$store.getters.isFornecedor && this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor) {
                const anexo = (this.boletimMedicao.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipoAnexoBoletimMedicaoEnum.DeclaracaoVinculoAssinadaPeloFornecedor);
                return anexo ? (anexo.nome || 'Arquivo já enviado') : null;
            }
            const tipoPorStatus = {
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor]: tipoAnexoBoletimMedicaoEnum.DeclaracaoVinculoAssinadaPeloFornecedor,
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro]: tipoAnexoBoletimMedicaoEnum.DeclaracaoVinculoAssinadaPeloFiscalTerceiro,
            };
            const tipo = tipoPorStatus[this.boletimMedicao.status];
            if (!tipo) return null;
            const anexo = (this.boletimMedicao.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipo);
            return anexo ? (anexo.nome || 'Arquivo já enviado') : null;
        },
        // TODO: Etapa de documentos complementares não será usada por agora.
        //mostrarBotaoEnviarDocumentosComplementaresParaAprovacao() {
            //return ((this.boletimMedicao.status == statusBoletimMedicaoEnum.AprovadoParaEnvioDocumentosComplementares ||
                //this.boletimMedicao.status == statusBoletimMedicaoEnum.DocumentosComplementaresDevolvidosParaCorrecao)
                //&& this.$store.getters.isFornecedor)
        //},
        // TODO: Etapa de documentos complementares não será usada por agora.
        //mostrarBotaoDevolucaoDocumentosComplementaresParaCorrecao() {
            //return this.boletimMedicao.status == statusBoletimMedicaoEnum.DocumentosComplementaresEnviadosParaAprovacao
                //&& (this.contrato.usuarioEhCadastrador || this.contrato.usuarioEhOrdenador)
        //},

        mostrarBotaoEnviarNotaFiscalParaAprovacao() {
            return ((this.boletimMedicao.status == statusBoletimMedicaoEnum.AprovadoParaEnvioNotaFiscal ||
                this.boletimMedicao.status == statusBoletimMedicaoEnum.NotaFiscalDevolvidaParaCorrecao)
                && this.$store.getters.isFornecedor)
        },

        mostrarBotaoDevolverNotaFiscalParaCorrecao() {
            return this.boletimMedicao.status == statusBoletimMedicaoEnum.NotaFiscalEnviadaParaAprovacao
                && (this.contrato.usuarioEhGestorContratos || this.contrato.usuarioEhOrdenador)
        },

        mostrarBotaoAprovacaoParaCadastroRequisicao() {
            return this.boletimMedicao.status == statusBoletimMedicaoEnum.NotaFiscalEnviadaParaAprovacao
                && (this.contrato.usuarioEhGestorContratos || this.contrato.usuarioEhOrdenador)
        },

        mostrarBotaoGerarRequisicaoBoletimMedicao() {
            return this.boletimMedicao.status == statusBoletimMedicaoEnum.NotaFiscalAprovada
                && (this.contrato.usuarioEhGestorContratos || this.contrato.usuarioEhOrdenador)
        },

        mostrarBotaoReiniciarProcesso() {
            return this.boletimMedicao.status == statusBoletimMedicaoEnum.NotaFiscalAprovada
                && this.contrato.usuarioEhOrdenador
        },

        mensagemConfirmacaoEnvioParaAprovacao() {
            if (this.boletimMedicao.total != 0) {
                return 'Confirma o envio do boletim de medição para análise?';
            } else {
                return `Deseja realmente <strong>enviar</strong> o Boletim de Medição nº ${this.boletimMedicao.numero} <strong>zerado</strong> para aprovação?`;
            }
        },

        indiceBmAtual() {
            if (this.boletimMedicao && this.boletimMedicao.numero) {
                const numero = this.boletimMedicao.numero;
                const indice = numero - 1;

                return indice;
            }

            console.warn('[PAI] BoletimMedicao ainda não tem número, enviando 0 padrão.');
            return 0;
        },

        valorTotalTodosBoletins() {
            const numeroBoletimAtual = this.obterNumeroBoletim(this.boletimMedicao && this.boletimMedicao.numero);
            const boletinsFiltrados = numeroBoletimAtual
                ? this.todosBoletinsMedicoes.filter(boletim => {
                    const numero = this.obterNumeroBoletim(boletim.numero);
                    return numero !== null && numero <= numeroBoletimAtual;
                  })
                : this.todosBoletinsMedicoes;

            return boletinsFiltrados.reduce((soma, boletim) => soma + (boletim.total || 0), 0);
        },

        declaracaoVinculoEditavel() {
            if (this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor)
                return !!this.boletimMedicao.declaracaoVinculoEditavel && this.$store.getters.isFornecedor;

            return this.boletimEditavel;
        },

        plantaFaladaEditavel() {
            if (this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor
                || this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor)
                return !!this.boletimMedicao.plantaFaladaEditavel && this.$store.getters.isFornecedor;

            if (this.boletimMedicao.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
                return this.$store.getters.isFornecedor;

            return this.boletimEditavel;
        },

        anexosEditavel() {
            return this.boletimEditavel;
        },

        podeTrocarImagemPlantaFalada() {
            if (this.boletimMedicao.status === statusBoletimMedicaoEnum.Criado
                || this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor
                || this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor)
                return true;

            return false;
        },

        isFiscalAprovandoFiscalObras() {
            return this.boletimMedicao.status === statusBoletimMedicaoEnum.EnviadoParaAprovacaoFiscalObras
                && (this.contrato.usuarioEhFiscalObra || this.contrato.usuarioEhOrdenador);
        },

        totalItensAprovacao() {
            return (this.boletimMedicao.itens || []).filter(i => !!i.valorUnitario).length;
        },

        podeAprovarBoletimFiscalObras() {
            if (!this.isFiscalAprovandoFiscalObras) return true;
            return this.totalItensAprovacao > 0 && this.itensAprovados.length === this.totalItensAprovacao;
        },
        temItemMemoriaEditavel() {
            const possuiItemEditavel = (itens = []) => {
                return itens.some(item => {
                    const valorUnitario = parseFloat(item?.valorUnitario);
                    const valorUnitarioValido = !isNaN(valorUnitario) && valorUnitario !== 0;

                    if (item?.status === statusItemBoletimMedicaoEnum.ReprovadoFiscalObras && valorUnitarioValido) {
                        return true;
                    }

                    if (Array.isArray(item?.subitens) && item.subitens.length > 0) {
                        return possuiItemEditavel(item.subitens);
                    }

                    return false;
                });
            };

            return possuiItemEditavel(this.boletimMedicao?.itens || []);
        },
        abasEmAjuste() {
            const isFornecedor = this.$store.getters.isFornecedor;

            const emAjusteFornecedor = isFornecedor
                && this.boletimMedicao.status === statusBoletimMedicaoEnum.DevolvidoParaCorrecaoFornecedor;

            if (!emAjusteFornecedor) {
                return [];
            }

            const abas = [];

            if (this.boletimMedicao.declaracaoVinculoEditavel) {
                abas.push(abaBoletimMedicaoCodigo.DeclaracaoVinculos);
            }

            if (this.boletimMedicao.plantaFaladaEditavel) {
                abas.push(abaBoletimMedicaoCodigo.PlantaFalada);
            }

            if (this.temItemMemoriaEditavel) {
                abas.push(abaBoletimMedicaoCodigo.MemoriaCalculo);
            }

            return abas;
        },
    },
    methods: {
        obterDescricaoStatusBoletimMedicao,
        obterClasseCorStatusBoletimMedicao,
        obterDescricaoUnidadeMedidaItemContrato,

        obterPlanejamentoDoBoletim() {
            const contratoId = this.boletimMedicao.contratoId || this.contrato.contratoId;
            if (!contratoId) return;
            this.planejamentoDoBoletim = null;
            BoletimMedicaoServicos.obterPlanejamentoFisicoFinanceiroPorContrato(contratoId)
                .then(response => {
                    if (response.success && response.data) {
                        this.planejamentoDoBoletim = response.data;
                    }
                })
                .catch(() => {
                    this.planejamentoDoBoletim = null;
                });
        },
        obterNumeroBoletim(valor) {
            if (valor === null || valor === undefined) return null;

            const numeroDireto = parseInt(valor, 10);
            if (!isNaN(numeroDireto) && numeroDireto > 0) return numeroDireto;

            const match = String(valor).match(/(\d+)/);
            if (!match || !match[1]) return null;

            const numeroExtraido = parseInt(match[1], 10);
            return isNaN(numeroExtraido) || numeroExtraido <= 0 ? null : numeroExtraido;
        },
        obterIndiceBoletimAtualCronograma() {
            const numeroBoletimAtual = this.obterNumeroBoletim(this.boletimMedicao && this.boletimMedicao.numero);
            return numeroBoletimAtual && numeroBoletimAtual > 0 ? numeroBoletimAtual - 1 : 0;
        },
        converterParaNumero(valor) {
            const numero = parseFloat(valor);
            return isNaN(numero) ? 0 : numero;
        },
        obterValorParcialBm(bm) {
            if (!bm) return 0;
            return this.converterParaNumero(
                bm.parcial !== undefined && bm.parcial !== null ? bm.parcial : bm.valor
            );
        },
        formatarDataPeriodoBoletim(data) {
            if (!data) return '';
            const dataFormatada = this.$moment(data);
            if (!dataFormatada.isValid() || dataFormatada.year() <= 1) return '';
            return dataFormatada.format('DD/MM/YYYY');
        },
        obterPeriodoBoletimAtual() {
            const inicio = this.formatarDataPeriodoBoletim(this.boletimMedicao && this.boletimMedicao.dataInicio);
            const fim = this.formatarDataPeriodoBoletim(this.boletimMedicao && this.boletimMedicao.dataFim);

            if (inicio && fim) return `${inicio} - ${fim}`;
            if (inicio) return inicio;
            if (fim) return fim;

            return this.boletimMedicao && this.boletimMedicao.competencia
                ? `${this.$moment(this.boletimMedicao.competencia).startOf('month').format('DD/MM/YYYY')} - ${this.$moment(this.boletimMedicao.competencia).endOf('month').format('DD/MM/YYYY')}`
                : '';
        },
        obterFinanceiroProjetadoCronograma(dados = {}) {
            const indiceBoletimAtual = this.obterIndiceBoletimAtualCronograma();
            const numeroBoletimAtual = indiceBoletimAtual + 1;

            const bmPlanejadoTotal = dados.total && dados.total.planejado && dados.total.planejado.bms &&
                dados.total.planejado.bms[indiceBoletimAtual];
            if (bmPlanejadoTotal) return this.obterValorParcialBm(bmPlanejadoTotal);

            if (Array.isArray(dados.itens) && dados.itens.length > 0) {
                let totalPlanejadoItens = 0;
                let encontrouValorPlanejado = false;

                dados.itens.forEach(item => {
                    if (Array.isArray(item.medicoes)) {
                        const medicaoAtual = item.medicoes.find(m => this.obterNumeroBoletim(m.boletim) === numeroBoletimAtual);
                        if (medicaoAtual) {
                            encontrouValorPlanejado = true;
                            totalPlanejadoItens += this.converterParaNumero(medicaoAtual.valorCalculado || medicaoAtual.valorPlanejado || 0);
                            return;
                        }
                    }

                    const bmPlanejadoItem = item && item.planejado && Array.isArray(item.planejado.bms)
                        ? item.planejado.bms[indiceBoletimAtual]
                        : null;
                    if (bmPlanejadoItem) {
                        encontrouValorPlanejado = true;
                        totalPlanejadoItens += this.obterValorParcialBm(bmPlanejadoItem);
                        return;
                    }

                    if (Array.isArray(item.historicoMedicoes)) {
                        const historicoAtual = item.historicoMedicoes.find(h => this.obterNumeroBoletim(h.numeroBoletim) === numeroBoletimAtual);
                        if (historicoAtual) {
                            encontrouValorPlanejado = true;
                            totalPlanejadoItens += this.converterParaNumero(historicoAtual.valorPlanejado || historicoAtual.valorCalculado || 0);
                        }
                    }
                });

                if (encontrouValorPlanejado) return totalPlanejadoItens;
            }

            if (dados.valorPlanejado !== null && dados.valorPlanejado !== undefined) {
                return this.converterParaNumero(dados.valorPlanejado);
            }

            return this.converterParaNumero(this.dadosContratoHeader && this.dadosContratoHeader.financeiroProjetado);
        },
        obterFinanceiroExecutadoCronograma(dados = {}) {
            const indiceBoletimAtual = this.obterIndiceBoletimAtualCronograma();
            const numeroBoletimAtual = indiceBoletimAtual + 1;

            if (this.boletimMedicao && this.boletimMedicao.total !== null && this.boletimMedicao.total !== undefined) {
                return this.converterParaNumero(this.boletimMedicao.total);
            }

            if (Array.isArray(this.todosBoletinsMedicoes) && this.todosBoletinsMedicoes.length > 0) {
                const boletimAtual = this.todosBoletinsMedicoes.find(b => this.obterNumeroBoletim(b.numero) === numeroBoletimAtual);
                if (boletimAtual) return this.converterParaNumero(boletimAtual.total);
            }

            const bmRealizadoTotal = dados.total && dados.total.realizado && dados.total.realizado.bms &&
                dados.total.realizado.bms[indiceBoletimAtual];
            if (bmRealizadoTotal) return this.obterValorParcialBm(bmRealizadoTotal);

            if (Array.isArray(dados.itens) && dados.itens.length > 0) {
                let totalRealizadoItens = 0;
                let encontrouValorRealizado = false;

                dados.itens.forEach(item => {
                    const bmRealizadoItem = item && item.realizado && Array.isArray(item.realizado.bms)
                        ? item.realizado.bms[indiceBoletimAtual]
                        : null;
                    if (bmRealizadoItem) {
                        encontrouValorRealizado = true;
                        totalRealizadoItens += this.obterValorParcialBm(bmRealizadoItem);
                        return;
                    }

                    if (Array.isArray(item.medicoes)) {
                        const medicaoAtual = item.medicoes.find(m => this.obterNumeroBoletim(m.boletim) === numeroBoletimAtual);
                        const possuiExecutadoMedicao = medicaoAtual &&
                            ((medicaoAtual.valorExecutado !== undefined && medicaoAtual.valorExecutado !== null) ||
                             (medicaoAtual.valorRealizado !== undefined && medicaoAtual.valorRealizado !== null));
                        if (possuiExecutadoMedicao) {
                            encontrouValorRealizado = true;
                            totalRealizadoItens += this.converterParaNumero(medicaoAtual.valorExecutado || medicaoAtual.valorRealizado || 0);
                            return;
                        }
                    }

                    if (Array.isArray(item.historicoMedicoes)) {
                        const historicoAtual = item.historicoMedicoes.find(h => this.obterNumeroBoletim(h.numeroBoletim) === numeroBoletimAtual);
                        const possuiExecutadoHistorico = historicoAtual &&
                            ((historicoAtual.valorExecutado !== undefined && historicoAtual.valorExecutado !== null) ||
                             (historicoAtual.valorRealizado !== undefined && historicoAtual.valorRealizado !== null));
                        if (possuiExecutadoHistorico) {
                            encontrouValorRealizado = true;
                            totalRealizadoItens += this.converterParaNumero(historicoAtual.valorExecutado || historicoAtual.valorRealizado || 0);
                        }
                    }
                });

                if (encontrouValorRealizado) return totalRealizadoItens;
            }

            if (dados.valorExecutado !== null && dados.valorExecutado !== undefined) {
                return this.converterParaNumero(dados.valorExecutado);
            }

            return this.converterParaNumero(this.dadosContratoHeader && this.dadosContratoHeader.financeiroExecutado);
        },

        excluir() {
            this.$swal({
                title: 'Excluir Boletim de Medição?',
                html: 'Esta ação é <b>irreversível</b>. O BM e todos os seus itens, documentos e histórico serão permanentemente excluídos.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (!result.value) return;
                this.$store.dispatch('addRequest');
                BoletimMedicaoServicos.excluirBoletimMedicao(this.contrato.contratoId, this.boletimMedicao.boletimMedicaoId)
                    .then(response => {
                        if (response && response.success) {
                            this.$toast.success('Boletim de Medição excluído com sucesso.');
                            this.voltar();
                        } else {
                            const msg = response && response.errors && response.errors.length ? response.errors[0] : 'Erro ao excluir o Boletim de Medição.';
                            this.$toast.error(msg);
                        }
                    })
                    .finally(() => {
                        this.$store.dispatch('removeRequest');
                    });
            });
        },

        voltar() {
            this.$emit('recarregarListaBoletinsMedicao')
            this.$router.push({
                name: 'FornecedorContratos_BoletinsMedicoes'
            })
        },

        obterHistoricoAditivos() {
            if (!this.contrato || !this.contrato.contratoId) return
            ContratosServicos.obterHistoricoAditivos(this.contrato.contratoId)
                .then(response => {
                    if (response && response.success && response.data) {
                        this.historicoAditivos = response.data
                    }
                })
        },

        async obterBoletimMedicao() {
            this.$store.dispatch('addRequest')

            try {
                const response = await BoletimMedicaoServicos.obterBoletimMedicao(this.contrato.contratoId, this.$route.params.idBoletimMedicao)

                if (response) {
                    if (response.success) {
                        this.boletimMedicao = response.data
                        this.boletimMedicao.anexos = this.recriarAnexos(this.boletimMedicao.anexos)
                        this.historicoMaisRecente = this.boletimMedicao.historico.slice().sort((a, b) => new Date(b.data) - new Date(a.data))[0]
                        this.obterPlanejamentoDoBoletim()

                        if (this.dadosContratoHeader) {
                            this.dadosContratoHeader = {
                                ...this.dadosContratoHeader,
                                financeiroProjetado: this.obterFinanceiroProjetadoCronograma(),
                                financeiroExecutado: this.obterFinanceiroExecutadoCronograma()
                            };
                        }

                        if (this.contrato.fornecedor && this.contrato.fornecedor.cnpj) {
                            const cnpjLimpo = this.contrato.fornecedor.cnpj.replace(/\D/g, '');
                            const responseLogo = await FornecedoresServicos.obterLogo(cnpjLimpo);
                            if (responseLogo.success && responseLogo.data && responseLogo.data.logo) {
                                this.fornecedorLogoCurvaS = responseLogo.data.logo;
                                this.fornecedorLogoMemoriaCalculo = responseLogo.data.logo;
                                this.fornecedorLogoPlantaFalada = responseLogo.data.logo;
                                this.fornecedorLogoItensMedicao = responseLogo.data.logo;
                            } else {
                                this.fornecedorLogoCurvaS = null;
                                this.fornecedorLogoMemoriaCalculo = null;
                                this.fornecedorLogoPlantaFalada = null;
                                this.fornecedorLogoItensMedicao = null;
                            }
                        }
                    } else {
                        this.erros = response.errors
                    }
                }
            } catch (error) {
                this.$toast.error(
                    'Não foi possível obter o Boletim de medição ou a logo do fornecedor',
                    'Erro',
                    this.$toastConfig.error
                )
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        recarregarBoletimELista() {
            this.obterBoletimMedicao();
            this.obterTodosBoletinsMedicoes();
        },

        obterTodosBoletinsMedicoes() {
            this.$store.dispatch('addRequest')

            let filtro = {
                contratoId: this.contrato.contratoId,
                processo: '',
                solicitante: '',
                dataInicio: null,
                dataFim: null,
                situacao: null
            }

            BoletimMedicaoServicos.obterBoletinsMedicoes(filtro)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.todosBoletinsMedicoes = response.data

                        if (this.dadosContratoHeader) {
                            this.dadosContratoHeader = {
                                ...this.dadosContratoHeader,
                                financeiroProjetado: this.obterFinanceiroProjetadoCronograma(),
                                financeiroExecutado: this.obterFinanceiroExecutadoCronograma()
                            };
                        }
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            .catch(error => {
                this.$store.dispatch('removeRequest')
                console.error('Erro ao obter boletins de medição:', error)
            })
        },

        async carregarDadosCronogramaHeader() {
            this.$store.dispatch('addRequest');

            let logoFornecedorUrl = null;
            if (this.contrato.fornecedor && this.contrato.fornecedor.cnpj) {
                const cnpjLimpo = this.contrato.fornecedor.cnpj.replace(/\D/g, '');
                const responseLogo = await FornecedoresServicos.obterLogo(cnpjLimpo);
                if (responseLogo.success && responseLogo.data && responseLogo.data.logo) {
                    logoFornecedorUrl = responseLogo.data.logo;
                    this.fornecedorLogoUrl = logoFornecedorUrl; // Store it in data property
                }
            }

            BoletimMedicaoServicos.obterPlanejamentoFisicoFinanceiro(this.boletimMedicao.contratoId || this.contrato.contratoId, this.boletimMedicao.boletimMedicaoId, false)
                .then(response => {
                    let dados = {};
                    if (response && response.success) {
                        dados = response.data;
                    } else {
                        let msg = 'Erro ao carregar dados do cronograma.';

                        if (response.notFound) {
                            msg = 'Planejamento Físico-Financeiro não encontrado para o contrato.';
                        } else if (response.error && response.error.response && response.error.response.data && response.error.response.data.message) {
                           msg = response.error.response.data.message;
                        }

                        this.$toast.warning(msg, 'Atenção', this.$toastConfig.warning);
                    }

                    this.dadosContratoHeader = {
                        logoFornecedorUrl: this.fornecedorLogoUrl, // Use the stored data property
                        numeroContrato: this.contratoDoBoletim.codContrato,
                        contratada: this.contratoDoBoletim.fornecedor ? `${this.contratoDoBoletim.fornecedor.cnpj} - ${this.contratoDoBoletim.fornecedor.nome}` : '',
                        ordemServico: '-',
                        objeto: this.contratoDoBoletim.objeto,
                        medicao: this.boletimMedicao.numero,
                        periodo: this.obterPeriodoBoletimAtual(),
                        valorContrato: dados.valorTotalContrato || this.contratoDoBoletim.valorTotal || 0,
                        financeiroProjetado: this.obterFinanceiroProjetadoCronograma(dados),
                        financeiroExecutado: this.obterFinanceiroExecutadoCronograma(dados),
                        valorMedicao: this.boletimMedicao.total || 0,
                        totalMedido: this.valorTotalTodosBoletins || 0,
                        saldoContratual: (this.contratoDoBoletim.valorTotal || 0) - (this.valorTotalTodosBoletins || 0)
                    };
                })
                .catch(error => {
                     this.$toast.warning('Erro ao carregar dados do cronograma.', 'Atenção', this.$toastConfig.warning);
                     this.dadosContratoHeader = {
                        logoFornecedorUrl: logoFornecedorUrl,
                        numeroContrato: this.contratoDoBoletim.codContrato,
                        contratada: this.contratoDoBoletim.fornecedor ? `${this.contratoDoBoletim.fornecedor.cnpj} - ${this.contratoDoBoletim.fornecedor.nome}` : '',
                        ordemServico: '-',
                        objeto: this.contratoDoBoletim.objeto,
                        medicao: this.boletimMedicao.numero,
                        periodo: this.obterPeriodoBoletimAtual(),
                        valorContrato: this.contratoDoBoletim.valorTotal || 0,
                        financeiroProjetado: this.obterFinanceiroProjetadoCronograma(),
                        financeiroExecutado: this.obterFinanceiroExecutadoCronograma(),
                        valorMedicao: this.boletimMedicao.total || 0,
                        totalMedido: this.valorTotalTodosBoletins || 0,
                        saldoContratual: (this.contratoDoBoletim.valorTotal || 0) - (this.valorTotalTodosBoletins || 0)
                    };
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        recriarAnexos(anexos) {
            let anexosRecriados = []

            anexos.forEach(function (anexo) {
                const nomeOriginal = anexo.nomeDocumento || anexo.nomeArquivo || anexo.nome || ''
                const possuiConteudoArquivo = anexo.arquivo && anexo.arquivo.length
                const arquivoAnexo = possuiConteudoArquivo
                    ? new File([new Blob([anexo.arquivo])], nomeOriginal)
                    : null

                let tipoAnexo = tiposAnexo.find(item => item.id === anexo.tipoAnexoBoletimMedicao)
                const tipoDescricao = tipoAnexo ? tipoAnexo.descricao : anexo.tipoAnexoBoletimMedicaoDescricao

                anexosRecriados.push({
                    boletimMedicaoId: anexo.boletimMedicaoId,
                    documentoBoletimMedicaoId: anexo.documentoBoletimMedicaoId,
                    nome: nomeOriginal,
                    nomeDocumento: nomeOriginal,
                    nomeArquivo: nomeOriginal,
                    caminhoDocumento: anexo.caminhoDocumento,
                    arquivo: arquivoAnexo,
                    tipoAnexoBoletimMedicao: tipoAnexo ? tipoAnexo.id : anexo.tipoAnexoBoletimMedicao,
                    tipo: tipoAnexo ? tipoAnexo.id : anexo.tipoAnexoBoletimMedicao,
                    tipoDescricao: tipoDescricao,
                    tipoAnexoBoletimMedicaoDescricao: tipoDescricao,
                    data: anexo.data,
                    tamanho: anexo.tamanho
                })
            })

            return anexosRecriados
        },

        atualizarBoletimMedicao() {
            this.$router.push({
                name: 'FornecedorContratos_BoletinsMedicoes_Atualizar',
                params: { idBoletimMedicao: this.boletimMedicao.boletimMedicaoId }
            })
        },

        /* Funcionalidade não vai ser usada
        confirmarCancelamentoBoletimMedicao(justificativa) {
            this.$store.dispatch('addRequest')

            let dto = {
                boletimMedicaoId: this.boletimMedicao.boletimMedicaoId,
                justificativa: justificativa,
            }

            BoletimMedicaoServicos.cancelarBoletimMedicao(this.contrato.contratoId, dto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('recarregarListaBoletinsMedicao')
                        this.$router.push({ name: 'FornecedorContratos_BoletinsMedicoes' })
                        this.$toast.success(
                            'Boletim de medição cancelado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.erros = response.errors

                        this.$toast.error(
                            'Erro ao cancelar o Boletim de medição',
                            'Erro',
                            this.$toastConfig.error
                        )
                    }
                }

                this.$store.dispatch('removeRequest')
            })
            .catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Erro ao cancelar o Boletim de medição',
                    'Erro',
                    this.$toastConfig.error
                )
            })
        },
        */

        adicionarItensBoletimMedicao(itensBoletimMedicao) {
            this.$store.dispatch('addRequest')

            itensBoletimMedicao.forEach((item) => {
                item.boletimMedicaoId = this.boletimMedicao.boletimMedicaoId
            })

            let dto = {
                boletimMedicaoId: this.boletimMedicao.boletimMedicaoId,
                itens: itensBoletimMedicao,
            }

            BoletimMedicaoServicos.adicionarItemBoletimMedicao(
                this.contrato.contratoId, dto
            )
            .then(response => {
                if (response) {
                    if (response.status === 200) {
                        this.obterBoletimMedicao()

                        this.$toast.success(
                            'Item de medição adicionado com sucesso!',
                            'Ok',
                            this.$toastConfig.success
                        )
                    }
                    else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            .catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Não foi possível inserir o item do Boletim de medição',
                    'Erro',
                    this.$toastConfig.error
                )
            })
        },

        excluirItemBoletimMedicao(boletimMedicaoId, itemBoletimMedicaoId) {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.excluirItemBoletimMedicao(this.contrato.contratoId, boletimMedicaoId, itemBoletimMedicaoId)
            .then(response => {
                if (response) {
                    if (response.status === 200) {
                        this.obterBoletimMedicao()

                        this.$toast.success(
                            'Item de medição excluído com sucesso!',
                            'Ok',
                            this.$toastConfig.success
                        )
                    }
                    else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            .catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Não foi possível excluir o item do Boletim de medição',
                    'Erro',
                    this.$toastConfig.error
                )
            })
        },

        concluirEtapaReassinar(dto) {
            const aprovadas = this.abasAprovadasPeloFiscal;
            dto.planilhaMedicaoEditavel   = !aprovadas.includes('planilha_medicao');
            dto.memoriaCalculoEditavel    = !aprovadas.includes('memoria_calculo');
            dto.cronogramaEditavel        = !aprovadas.includes('cronograma');
            dto.curvaSEditavel            = !aprovadas.includes('curva_s');
            dto.plantaFaladaEditavel      = !aprovadas.includes('planta_falada');
            dto.declaracaoVinculoEditavel = !aprovadas.includes('declaracao_vinculos');
            this.concluirEtapa(dto);
        },

        obterMensagemErroIntegracao(resposta) {
            if (!resposta) return 'Não foi possível processar a integração com o SEI.'

            if (Array.isArray(resposta.errors) && resposta.errors.length > 0) {
                return resposta.errors.join('; ')
            }

            if (typeof resposta.message === 'string' && resposta.message.trim()) {
                return resposta.message
            }

            return 'Não foi possível processar a integração com o SEI.'
        },

        async abrirModalEnvioSei(dto) {
            this.$store.dispatch('addRequest')

            try {
                const payload = {
                    numeroProcesso: dto.numeroProcesso || '',
                    origem: 'BM_REQUISICAO'
                }

                const respostaMapeamento = await IntegracaoSeiDocumentosServicos.mapearParametrosEAnexosSei(
                    this.contrato.contratoId,
                    this.boletimMedicao.boletimMedicaoId,
                    payload
                )

                if (!respostaMapeamento || respostaMapeamento.success === false) {
                    this.$toast.error(
                        this.obterMensagemErroIntegracao(respostaMapeamento),
                        'Erro',
                        this.$toastConfig.error
                    )
                    return
                }

                const dadosMapeamento = respostaMapeamento.data || respostaMapeamento
                const anexosElegiveis = Array.isArray(dadosMapeamento.anexos)
                    ? dadosMapeamento.anexos
                    : []

                if (anexosElegiveis.length === 0) {
                    this.$toast.warning(
                        'Nenhum anexo elegível para envio ao SEI (Outros Documentos e Assinada(o) por Suape).',
                        'Atenção',
                        this.$toastConfig.warning
                    )
                    return
                }

                const parametros = dadosMapeamento.parametros || {}

                this.contextoEnvioSei = {
                    numeroProcesso: parametros.numeroProcesso || payload.numeroProcesso,
                    anexos: anexosElegiveis,
                    parametros: {
                        ...parametros,
                        origem: parametros.origem || payload.origem
                    }
                }

                this.mostrarModalEnvioSei = true
            } catch (error) {
                this.$toast.error(
                    'Não foi possível mapear os documentos para envio ao SEI.',
                    'Erro',
                    this.$toastConfig.error
                )
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        fecharModalEnvioSei() {
            this.mostrarModalEnvioSei = false
            this.contextoEnvioSei = {
                numeroProcesso: '',
                anexos: [],
                parametros: {}
            }
        },

        async concluirEnvioSei(resultado) {
            if (!resultado) return

            const resultados = (resultado.itens || []).map(item => ({
                nomeDocumento: item.nomeDocumento || item.nomeArquivo || item.nome || '',
                sucesso: item.statusEnvio === 'ENVIADO',
                mensagem: item.mensagemEnvio || ''
            }))

            if (resultados.length > 0) {
                try {
                    await IntegracaoSeiDocumentosServicos.registrarEnvioSeiHistorico(
                        this.contrato.contratoId,
                        this.boletimMedicao.boletimMedicaoId,
                        resultados
                    )
                    this.obterBoletimMedicao()
                } catch {
                    // falha silenciosa — o envio SEI já ocorreu
                }
            }

            if (resultado.erros > 0) {
                this.$toast.warning(
                    `Envio SEI finalizado com ${resultado.erros} erro(s) e ${resultado.enviados} sucesso(s).`,
                    'Atenção',
                    this.$toastConfig.warning
                )
                return
            }

            this.$toast.success(
                `Envio SEI concluído: ${resultado.enviados} documento(s) enviado(s).`,
                'OK',
                this.$toastConfig.success
            )
        },

        concluirEtapa(dto) {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.concluirEtapaBoletimMedicao(this.contrato.contratoId, this.boletimMedicao.boletimMedicaoId, dto)
                .then(response => {
                    if (!response.success) {
                        if (response.errors && response.errors.length > 0) {
                            this.$toast.error(
                                'Não foi possível concluir a etapa do Boletim de Medição',
                                'Erro',
                                this.$toastConfig.error
                            );

                            this.erros = response.errors;
                        }
                    }

                    if (response.data && response.data.success) {
                        this.$toast.success(
                            'Boletim de medição atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )

                        this.itensAprovados = [];
                        this.erros = []
                        this.obterBoletimMedicao()
                        this.obterTodosBoletinsMedicoes()

                        if (dto.etapa === this.etapaBoletimMedicaoEnum.CadastroRequisicao) {
                            this.abrirModalEnvioSei(dto)
                        }
                    }
                })
                .catch(error => {
                    this.$store.dispatch('removeRequest')
                    this.$toast.error(
                        'Erro ao atualizar o Boletim de medição',
                        'Erro',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        downloadAnexoHistorico(documentoHistoricoBoletimMedicao) {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.downloadAnexoHistoricoBoletimMedicao(this.contrato.contratoId, this.boletimMedicao.boletimMedicaoId, documentoHistoricoBoletimMedicao.documentoHistoricoBoletimMedicaoId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Não foi possível fazer o download do arquivo',
                                'Erro',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(response, documentoHistoricoBoletimMedicao.nomeArquivo)
                        }
                    } else {
                        this.erros = response.errors
                    }

                    this.$store.dispatch('removeRequest')
                })
                .catch(error => {
                    this.$toast.error(
                        'Não foi possível fazer o download do arquivo',
                        'Erro',
                        this.$toastConfig.error
                    )
                    this.$store.dispatch('removeRequest')
                })
        },

        atualizarItemBoletimMedicao(itemBoletimMedicao) {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.atualizarItemBoletimMedicao(this.contrato.contratoId, itemBoletimMedicao)
            .then(response => {
                if (response) {
                    if (response.status === 200) {
                        this.obterBoletimMedicao()

                        this.$toast.success(
                            'Item de medição atualizado com sucesso!',
                            'Ok',
                            this.$toastConfig.success
                        )
                    }
                    else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            .catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Não foi possível atualizar o item do Boletim de medição',
                    'Erro',
                    this.$toastConfig.error
                )
            })
        },

        itemAtualizado(itemBoletimMedicao) {
            this.atualizarItemBoletimMedicao(itemBoletimMedicao)
        },

        obterVisualizacaoAbasBoletinsMedicao() {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.obterVisualizacaoAbasBoletinsMedicao(this.contrato.contratoId, this.$route.params.idBoletimMedicao)
                .then(response => {
                    if (response.data && response.data.success) {
                        this.visualizacaoAbasBoletinsMedicao = response.data.data
                    } else {
                        this.erros = response.errors
                    }
                })
                .catch(error => {
                    this.erros = error;
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        ativarAbaCronograma() {
            this.abaCronogramaAtiva = true;
            this.carregarDadosCronogramaHeader();
        },

        ativarAbaDeclaracaoVinculo() {
            this.abaDeclaracaoVinculoAtiva = true;
            if (!this.dadosContratoHeader) {
                 this.carregarDadosCronogramaHeader();
            }
            this.obterDeclaracaoVinculo();
        },

        obterDeclaracaoVinculo() {
            this.$store.dispatch('addRequest');
            BoletimMedicaoServicos.obterDeclaracaoVinculoPorBoletimMedicao(this.boletimMedicao.boletimMedicaoId)
                .then(response => {
                    if (response && response.success && response.data) {
                        const data = response.data;
                       // console.log('Dados da Declaração de Vínculo:', data);
                        this.declaracaoVinculoId = data.id || data.declaracaoVinculoId || data.declaracaoId || data.boletimMedicaoId || this.boletimMedicao.boletimMedicaoId;

                        const lista = Array.isArray(data) ? data : (data.profissionais || []);

                        this.itensDeclaracaoVinculo = lista.map(item => {
                            return {
                                id: item.id,
                                profissionalId: item.profissionalId,
                                nomeCompleto: item.nomeCompleto,
                                cpf: item.cpf,
                                cargo: item.cargo,
                                funcao: item.funcao,
                                registroProfissional: item.registroProfissional
                            }
                        });
                    } else {
                        this.itensDeclaracaoVinculo = [];
                        this.declaracaoVinculoId = null;
                    }
                })
                .catch(error => {
                    this.itensDeclaracaoVinculo = [];
                    this.declaracaoVinculoId = null;
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        salvarProfissional(profissional) {
            this.$store.dispatch('addRequest');

            if (profissional.cpf) {
                profissional.cpf = profissional.cpf.replace(/\D/g, '');
            }

            if (this.declaracaoVinculoId) {
                // Se já existe a declaração, inclui o profissional
                // Adiciona o boletimMedicaoId ao DTO do profissional, caso o backend precise
                const dto = {
                    ...profissional,
                    boletimMedicaoId: this.boletimMedicao.boletimMedicaoId
                };
                // Remove ID se for string vazia ou nulo para evitar erro de GUID inválido
                if (!dto.id) delete dto.id;
                if (!dto.profissionalId) delete dto.profissionalId;

                BoletimMedicaoServicos.incluirProfissionalVinculo(this.declaracaoVinculoId, dto)
                    .then(response => {
                        if (response) {
                            this.$toast.success('Profissional incluído com sucesso!');
                            this.obterDeclaracaoVinculo();
                            if (this.$refs.declaracaoVinculoTab) {
                                this.$refs.declaracaoVinculoTab.fecharModalAdicionar();
                            }
                        }
                        this.$store.dispatch('removeRequest');
                    })
                    .catch(error => {
                        this.$store.dispatch('removeRequest');
                        this.$toast.error('Erro ao incluir profissional.');
                    });
            } else {
                // Se não existe, cria a declaração
                const dto = {
                    boletimMedicaoId: this.boletimMedicao.boletimMedicaoId,
                    profissionais: [profissional]
                };
                BoletimMedicaoServicos.criarDeclaracaoVinculo(dto)
                    .then(response => {
                        if (response) {
                            this.$toast.success('Declaração criada com sucesso!');
                            this.obterDeclaracaoVinculo();
                            if (this.$refs.declaracaoVinculoTab) {
                                this.$refs.declaracaoVinculoTab.fecharModalAdicionar();
                            }
                        }
                        this.$store.dispatch('removeRequest');
                    })
                    .catch(error => {
                        this.$store.dispatch('removeRequest');
                        this.$toast.error('Erro ao criar declaração.');
                    });
            }
        },

        atualizarProfissional(dados) {
            this.$store.dispatch('addRequest');

            const profissionalId = dados.profissionalId || dados.id;
            const dto = {
                declaracaoVinculoId: dados.id,
                nomeCompleto: dados.nomeCompleto,
                cpf: dados.cpf ? dados.cpf.replace(/\D/g, '') : '',
                cargo: dados.cargo,
                funcao: dados.funcao,
                registroProfissional: dados.registroProfissional
            };

            BoletimMedicaoServicos.atualizarProfissionalVinculo(this.contrato.contratoId, profissionalId, dto)
                .then(response => {
                    if (response && response.success) {
                         this.$toast.success('Profissional atualizado com sucesso!');
                         this.obterDeclaracaoVinculo();
                         if (this.$refs.declaracaoVinculoTab) {
                             this.$refs.declaracaoVinculoTab.fecharModalAdicionar();
                         }
                    } else if (response && !response.success && response.message) {
                         this.$toast.warning(response.message);
                    } else {
                         this.$toast.error('Erro ao atualizar profissional.');
                    }
                    this.$store.dispatch('removeRequest');
                })
                .catch(error => {
                    this.$store.dispatch('removeRequest');
                    this.$toast.error('Erro ao atualizar profissional.');
                });
        },

        excluirProfissional(profissional) {
            //console.log('Tentando excluir profissional:', profissional);

            this.$store.dispatch('addRequest');

            if (!profissional || !profissional.id) {
                console.error('Erro: Profissional ou ID inválido', profissional);
                this.$store.dispatch('removeRequest');
                this.$toast.error('Erro ao identificar profissional para exclusão.');
                return;
            }

            BoletimMedicaoServicos.excluirProfissionalVinculo(profissional.id)
                .then(response => {
                    if (response && (response.status === 200 || response.status === 204)) {
                        this.$toast.success('Profissional excluído com sucesso!');
                        this.obterDeclaracaoVinculo();
                    } else {
                        console.warn('Resposta inesperada da exclusão:', response);
                    }
                    this.$store.dispatch('removeRequest');
                })
                .catch(error => {
                    console.error('Erro na exclusão:', error);
                    this.$store.dispatch('removeRequest');
                    this.$toast.error('Erro ao excluir profissional.');
                });
        },

        abaSelecionada(aba) {
            if (aba.codigo === abaBoletimMedicaoCodigo.Cronograma && this.temPlanejamentoDoBoletim) {
                this.ativarAbaCronograma();
            } else if (aba.codigo === abaBoletimMedicaoCodigo.DeclaracaoVinculos) {
                this.ativarAbaDeclaracaoVinculo();
            }
        },

        deveExibirCheckManual(codigoAba) {
            if (!this.abasComCheckManual.includes(codigoAba)) return false
            const visualizacao = this.visualizacaoAbasBoletinsMedicao.find(
                v => (v.abaBoletimMedicao?.codigo || '').toUpperCase() === codigoAba.toUpperCase()
            )
            return !!visualizacao
        },

        isAbaAtiva(codigoAba) {
            const visualizacao = this.visualizacaoAbasBoletinsMedicao.find(
                v => (v.abaBoletimMedicao?.codigo || '').toUpperCase() === codigoAba.toUpperCase()
            )
            if (!visualizacao) return false
            return visualizacao.configuracaoAbaBoletimMedicao?.ativo !== false
        },

        isAbaVisualizada(codigoAba) {
            const visualizacao = this.visualizacaoAbasBoletinsMedicao.find(
                v => (v.abaBoletimMedicao?.codigo || '').toUpperCase() === codigoAba.toUpperCase()
            )
            return visualizacao?.visualizada || false
        },

        async confirmarAbaManual(codigoAba, checked) {
            const visualizacao = this.visualizacaoAbasBoletinsMedicao.find(
                v => (v.abaBoletimMedicao?.codigo || '').toUpperCase() === codigoAba.toUpperCase()
            )
            if (!visualizacao) return

            this.$store.dispatch('addRequest')
            try {
                const response = await BoletimMedicaoServicos.atualizarVisualizacaoFornecedorAbaBoletimMedicao(
                    this.contrato.contratoId,
                    this.boletimMedicao.boletimMedicaoId,
                    visualizacao.abaBoletimMedicaoId,
                    checked
                )
                if (response.data && response.data.success) {
                    visualizacao.visualizada = checked
                }
            } catch (error) {
                this.$toast.error(`${error}`, 'Erro ao atualizar confirmação da aba', this.$toastConfig.error)
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },
    },

    created() {
        this.obterBoletimMedicao();
        this.obterVisualizacaoAbasBoletinsMedicao();
        this.obterTodosBoletinsMedicoes()
        this.obterHistoricoAditivos()
    },

    mounted() {
        const abaSalva = sessionStorage.getItem('abaMemoriaCalculo');

        if (abaSalva) {
            this.$nextTick(() => {
                this.abaAtiva = parseInt(abaSalva);
                sessionStorage.removeItem('abaMemoriaCalculo');
            });
        }
    },
}
</script>
<style>
.nav-tabs .nav-link.active {
    color: #007bff !important;
}

.check-manual-aba-banner {
    display: flex;
    align-items: center;
    background-color: #fff8e1;
    border: 1px solid #ffe082;
    border-radius: 4px;
    padding: 10px 16px;
    margin-bottom: 16px;
    font-size: 0.95rem;
    color: #5a4000;
}
</style>
